import type { BuildingSidebarSections } from "../../../types/buildings-sections/sidebar";

export const sidebar: BuildingSidebarSections = {
  dashboard: "Töölaud",
  actions: "Tegevused",
  documents: "Dokumendid",
  viewBuilding: "Hoone",
  viewProjects: "Projektid",
  projectLabel: "Projekt",
  wholeBuilding: "Kogu hoone",
  projectUnavailable: "Projekt pole saadaval",
  chooseProject: "Vali projekt",
  noProjectsYet: "Projekte veel pole",
  buildingData: "Hoone andmed",
  modelsSection: "Vaaturid",
  model3d: "Mudel",
  permits: "Load",
  team: "Meeskond",
  budgets: "Eelarved",
  payments: "Maksed",
  projections: "Prognoosid",
  lca: "CO2 analüüs",
  esg: "ESG",
  help: "Abi",
  building: "Hoone töölaud",
  materialBank: "Materjalipank",
  buildingsList: "Hooned",
};
